import React from "react";
import { SearchInput } from "react-admin";

const reviewFilters = [<SearchInput source="q" alwaysOn />];

export default reviewFilters;
